import { render, staticRenderFns } from "./BuyInReport.vue?vue&type=template&id=b1450f04&scoped=true"
import script from "./BuyInReport.vue?vue&type=script&lang=js"
export * from "./BuyInReport.vue?vue&type=script&lang=js"
import style0 from "./BuyInReport.vue?vue&type=style&index=0&id=b1450f04&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1450f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1450f04')) {
      api.createRecord('b1450f04', component.options)
    } else {
      api.reload('b1450f04', component.options)
    }
    module.hot.accept("./BuyInReport.vue?vue&type=template&id=b1450f04&scoped=true", function () {
      api.rerender('b1450f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/BuyInReport.vue"
export default component.exports